// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2ITIB","tab":"ProcedureTabs_tab__EFvfK"};